import { GameItem } from '@/types';

// Centralized bonus item configurations
// This ensures consistency between UI display and game logic

export const TURBO_ITEM: GameItem = {
  id: 'turbo-1',
  type: 'turbo',
  name: 'Turbo Boost',
  description: '',
  price: 0,
  effect: { duration: 2, value: 1.5 } // 3 seconds duration, 50% speed increase (1.5x multiplier)
};

export const NET_ITEM: GameItem = {
  id: 'net-1',
  type: 'net',
  name: 'Capture Net',
  price: 0,
  description: '',
  effect: { duration: 2, value: 1 } // 2 seconds immobilization
};

export const SHOES_ITEM: GameItem = {
  id: 'shoes-1',
  type: 'shoes',
  name: 'Speed Shoes',
  price: 0,
  description: '',
  effect: { duration: 10, value: 1.25 } // Round-based duration, 25% speed increase
};

export const GRENADE_ITEM: GameItem = {
  id: 'grenade-1',
  type: 'grenade',
  name: 'Grenade',
  price: 0,
  description: '',
  effect: { duration: 1.5, value: 300 } // 1.5s push duration, 300px push force
};

// Array of all available bonus items
export const AVAILABLE_BONUS_ITEMS: GameItem[] = [
  NET_ITEM,
  SHOES_ITEM,
  TURBO_ITEM,
  GRENADE_ITEM,
  // Placeholder items for future implementation
  ...Array.from({ length: 3 }, (_, index) => ({
    id: `placeholder-${index + 4}`,
    type: 'speed_boost' as const,
    name: `Coming Soon`,
    description: 'More items coming soon!',
    price: 0,
    effect: { duration: 0, value: 0 }
  }))
];

// Helper function to get item by type
export const getItemByType = (type: GameItem['type']): GameItem | undefined => {
  return AVAILABLE_BONUS_ITEMS.find(item => item.type === type);
};

// Helper function to get turbo item specifically
export const getTurboItem = (): GameItem => TURBO_ITEM;

// Helper function to get shoes item specifically
export const getShoesItem = (): GameItem => SHOES_ITEM;

// Helper function to get grenade item specifically
export const getGrenadeItem = (): GameItem => GRENADE_ITEM;